var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pointer"},[_c('div',{class:{ hovering: _vm.isHovering },on:{"mouseover":function($event){_vm.isHovering = true},"mouseout":function($event){_vm.isHovering = false}}},[_c('img',{staticStyle:{"border-radius":"130px"},attrs:{"src":_vm.addToUrl(_vm.speaker.speakerImageURL, _vm.cloudinaryParams),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"glitch__layers"},[_c('div',{class:[
          _vm.isHovering ? 'glitch__layer' : '',
          _vm.row2 ? 'glitch-position' : '' ],style:({
          'background-image':
            'url(' +
            _vm.addToUrl(_vm.speaker.speakerImageURL, _vm.cloudinaryParams2) +
            ')',
        })})]),_vm._v(" "),_c('div',{staticClass:"glitch__layers"},[_c('div',{class:[
          _vm.isHovering ? 'glitch__layer' : '',
          _vm.row2 ? 'glitch-position' : '' ],style:({
          'background-image':
            'url(' +
            _vm.addToUrl(_vm.speaker.speakerImageURL, _vm.cloudinaryParams2) +
            ')',
        })})]),_vm._v(" "),_c('div',{staticClass:"glitch__layers"},[_c('div',{class:[
          _vm.isHovering ? 'glitch__layer' : '',
          _vm.row2 ? 'glitch-position' : '' ],style:({
          'background-image':
            'url(' +
            _vm.addToUrl(_vm.speaker.speakerImageURL, _vm.cloudinaryParams2) +
            ')',
        })})]),_vm._v(" "),_c('div',{staticClass:"glitch__layers"},[_c('div',{class:[
          _vm.isHovering ? 'glitch__layer' : '',
          _vm.row2 ? 'glitch-position' : '' ],style:({
          'background-image':
            'url(' +
            _vm.addToUrl(_vm.speaker.speakerImageURL, _vm.cloudinaryParams2) +
            ')',
        })})])]),_vm._v(" "),_c('div',{staticClass:"speaker-info"},[_c('strong',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.speaker.speakerFirstName)+" "+_vm._s(_vm.speaker.speakerLastName)+"\n      "),(_vm.activeSpeaker == _vm.speaker._id)?_c('span',{staticClass:"material-symbols-outlined"},[_vm._v("\n        collapse_all\n      ")]):_c('span',{staticClass:"material-symbols-outlined"},[_vm._v(" expand_all ")])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.speaker.workshopName))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49b20032","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkshopSpeaker.vue
// module id = a/EN
// module chunks = 1